<template>
  <modal-container v-bind="props()">
    <div v-if="!noHeader" class="modal-header">
      <h5 class="modal-title">
        <slot name="title" />
      </h5>
      <modal-close :target="`#${id}`" />
    </div>
    <div :class="{ 'p-0': noPadding }" class="modal-body">
      <slot />
    </div>
    <div v-if="checkFooter()" class="modal-footer">
      <slot name="footer" />
    </div>
  </modal-container>
</template>

<script>
import ModalClose from './ModalClose.vue'
import ModalContainer from './ModalContainer.vue'

export default {
  name: 'AppModal',

  components: {
    ModalClose,
    ModalContainer
  },

  props: {
    id: { required: true },
    large: Boolean,
    noHeader: Boolean,
    noPadding: Boolean,
    small: Boolean,
    static: Boolean
  },

  methods: {
    checkFooter () {
      return this.$slots.footer
    },

    close () {
      $(`#${this.id}`).modal('hide')
    },

    props () {
      return this.$props
    }
  }
}
</script>
